import ChevronLeft from "@mui/icons-material/ChevronLeft";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useBreakpoints } from "core/hooks/useBreakpoints";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { BrandLogo } from "../BrandLogo";
import { CustomLink } from "../CustomLink";
import { FooterButtons } from "./FooterButtons";
import { FooterCategories } from "./FooterCategories";
import { FooterLegal } from "./FooterLegal";

export const Footer = memo(() => {
  const { t } = useTranslation("Fixhub", { keyPrefix: "Next:Core:Footer" });
  const { isDesktop } = useBreakpoints();
  return (
    <Box component="footer" sx={{ displayPrint: "none" }}>
      <Box
        display="flex"
        component="nav"
        bgcolor="background.paper"
        gap={4}
        sx={{
          py: 2,
          px: 4,
          flexWrap: "wrap",
          "& > *": { flex: 1, minWidth: "min(200px,100%)" },
        }}
      >
        {isDesktop && (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <CustomLink
              sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                flex: 1,
              }}
              href="/"
            >
              <Box maxWidth={200}>
                <BrandLogo />
              </Box>
              <Typography
                display="flex"
                variant="body2"
                alignItems="center"
                fontWeight={500}
                textTransform="uppercase"
              >
                <ChevronLeft />
                {t("backToHome")}
              </Typography>
            </CustomLink>
            <Divider orientation="vertical" />
          </Stack>
        )}
        <FooterCategories />
        <FooterButtons />
      </Box>
      <FooterLegal />
    </Box>
  );
});
Footer.displayName = "Footer";
